<template>
  <div class="fluid-viscosity-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>F = η · A · (dv/dy)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Pipe/Channel Walls -->
          <line x1="50" y1="60" x2="350" y2="60" stroke="#888" stroke-width="2" />
          <line x1="50" y1="180" x2="350" y2="180" stroke="#888" stroke-width="2" />

          <!-- Velocity Vectors (Profile) -->
          <g v-for="y in 9" :key="'v'+y">
             <line :x1="80" :y1="60 + y*12" :x2="80 + velocityX(60+y*12)" :y2="60 + y*12" stroke="#00d2ff" stroke-width="1.5" marker-end="url(#v-arrow)" />
          </g>
          
          <!-- Moving Particles -->
          <circle v-for="p in particles" :key="p.id" :cx="p.x" :cy="p.y" r="2" fill="rgba(0, 210, 255, 0.6)">
             <animate attributeName="cx" :from="p.x" :to="p.x + 300" :dur="p.speed + 's'" repeatCount="indefinite" />
          </circle>

          <defs>
            <marker id="v-arrow" markerWidth="6" markerHeight="4" refX="0" refY="2" orient="auto">
              <polygon points="0 0, 6 2, 0 4" fill="#00d2ff" />
            </marker>
          </defs>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>粘滞系数 η: {{ viscosity }} cP</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>调节流体粘性 (如: 水 vs 甘油)</label>
             <el-slider v-model="viscosity" :min="1" :max="100" size="mini"></el-slider>
          </div>
          <div class="row type-selector">
             <el-radio-group v-model="flowType" size="mini">
                <el-radio-button label="lamellar">层流</el-radio-button>
                <el-radio-button label="turbulent" disabled>瑞流 (暂不可用)</el-radio-button>
             </el-radio-group>
          </div>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>物理详解：</strong>粘性是流体内部阻碍流动的属性。由于流体分子间的吸引力和动量传递，靠近壁面的流速较低。<strong>牛顿内摩擦定律</strong>描述了这种力的关系。高粘性流体（如蜂蜜）阻力巨大，而理想流体则不计此力。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FluidViscosityViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      viscosity: 20,
      flowType: 'lamellar',
      particles: Array.from({ length: 25 }, (_, i) => {
        let y = 70 + Math.random() * 100;
        return {
          id: i,
          x: Math.random() * 100,
          y: y,
          speed: 1 // Placeholder, will compute in method
        }
      })
    }
  },
  watch: {
    viscosity: {
      immediate: true,
      handler() {
        this.particles.forEach(p => {
          let v = this.velocityX(p.y) / 10;
          p.speed = 10 / (v * (101 - this.viscosity)/50); 
        });
      }
    }
  },
  methods: {
    velocityX(y) {
      // parabolic velocity profile for laminar pipe flow: v(y) = v_max * (1 - (r/R)^2)
      let mid = 120;
      let r = Math.abs(y - mid);
      let R = 60;
      let v_max = 80;
      return v_max * (1 - Math.pow(r/R, 2));
    }
  }
}
</script>

<style scoped lang="scss">
.fluid-viscosity-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; 
  label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } 
}
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
